var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_17368)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_17368",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_17368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2819 3H1V23H35.2819V3Z",
    fill: "#D00027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9967 7.99498C13.7553 7.99498 15.9983 10.2313 15.9983 12.9967C15.9983 15.7553 13.762 17.9983 10.9967 17.9983C8.23803 17.9983 5.99498 15.762 5.99498 12.9967C6.00168 10.238 8.23803 7.99498 10.9967 7.99498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2487 8.99933C14.4583 8.99933 16.2461 10.7938 16.2461 12.9966C16.2461 15.2062 14.4583 16.994 12.2487 16.994C10.0392 16.994 8.25142 15.1995 8.25142 12.9966C8.25142 10.7871 10.0392 8.99933 12.2487 8.99933Z",
    fill: "#D00027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2216 12.9967L17.5986 13.7667L17.987 12.5815L15.2216 12.9967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2216 12.9966L17.5986 12.2266L17.987 13.4118L15.2216 12.9966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 10.6197V13.1172H18.2012L16.9491 10.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 10.6197L18.4222 12.6418L17.4111 13.3783L16.9491 10.6197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 15.3736L18.4222 13.3515L17.4111 12.615L16.9491 15.3736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9491 15.3736V12.8761H18.2012L16.9491 15.3736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7479 11.5303L17.3709 12.3003L17.7526 13.4854L19.7479 11.5303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7479 11.5303L18.2749 13.5524L17.2638 12.8159L19.7479 11.5303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7479 14.463L18.2749 12.4409L17.2638 13.1774L19.7479 14.463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7479 14.463L17.3709 13.693L17.7526 12.5079L19.7479 14.463Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_17368",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_17368"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_17368",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/Turkey.885aed258cd4008c51ccf92052efb8f3.svg";
export { ForwardRef as ReactComponent };